<script>
  export let project = {};
  export let onClick = null;
  $: disabled = Boolean(project.disabled);

  $: nameParts = String(project.name || "").split(" ");
</script>

<button
  type="button"
  class:disabled
  class="intelligence_card"
  data-guide={project.id === "software-monitoring" ? "software-intelligence" : undefined}
  aria-disabled={disabled}
  title={disabled ? "This feature is not included in your license." : undefined}
  on:click={() => onClick?.(project)}
>
  <div class="intelligence_card_top">
    <span class="intelligence_type">
      <strong>Digital Twin</strong>
      <span class="type-separator">•</span>
      {project.type}
    </span>
    <span
      class:active={project.status === "Active"}
      class:not-included={project.status === "Not included"}
      class="intelligence_status"
    >
      {project.status}
    </span>
  </div>

  <div class="intelligence_card_content">
    <h3>
      {nameParts[0]}
      {#if nameParts.length > 1}
        <br />
        {nameParts.slice(1).join(" ")}
      {/if}
    </h3>
    <span class="intelligence_arrow" aria-hidden="true">
      <img src="/img/dashboard/arrow_right_white.svg" alt="" />
    </span>
  </div>

  <div class="intelligence_kpis">
    {#each project.kpis || [] as kpi}
      <div class="intelligence_kpi">
        <strong>{disabled ? "–" : kpi.value}</strong>
        <span>{kpi.label}</span>
      </div>
    {/each}
  </div>
</button>

<style>
  .intelligence_card {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    min-height: 10.5rem;
    /* Höchstens 4:5, damit die Karten auf hohen Fenstern nicht endlos wachsen. */
    max-height: calc(100cqi * 1.25);
    padding: clamp(1.25rem, 0.75rem + 0.8vw, 2.5rem);
    overflow: hidden;
    border: 1px solid var(--pax-black, #1c1c20);
    border-radius: 0.5rem;
    background: var(--pax-black, #1c1c20);
    color: #fff;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }

  .intelligence_card:hover,
  .intelligence_card:focus-visible {
    border-color: var(--pax-black, #1c1c20);
    background: #2a2a30;
    outline: none;
  }

  .intelligence_card.disabled {
    cursor: not-allowed;
  }

  .intelligence_card.disabled .intelligence_status.not-included {
    border-color: #b64b4b;
    color: #ff8f8f;
  }

  .intelligence_card.disabled:hover {
    background: #2a2a30;
  }

  .intelligence_card_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: clamp(0.75rem, 0.5rem + 0.35vw, 1.5rem);
  }

  .intelligence_card_content {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    margin-top: auto;
    padding-top: clamp(1.25rem, 0.75rem + 0.8vw, 2.5rem);
  }

  .intelligence_type,
  .intelligence_status {
    color: #b9bac1;
    font-size: clamp(0.625rem, 0.6vw, 0.95rem);
  }

  .intelligence_type {
    display: inline-flex;
    align-items: center;
  }

  .intelligence_type strong {
    color: var(--pax-white);
    font-size: inherit;
    font-weight: 400;
    line-height: inherit;
  }

  .type-separator {
    margin: 0 clamp(0.25rem, 0.15rem + 0.12vw, 0.5rem);
  }

  .intelligence_status {
    display: inline-flex;
    align-items: center;
    padding: clamp(0.25rem, 0.15rem + 0.12vw, 0.5rem)
      clamp(0.5rem, 0.3rem + 0.2vw, 0.8rem);
    border: 1px solid #45464d;
    border-radius: 999rem;
  }

  .intelligence_status.active {
    border-color: #5d8d63;
    color: #9dde9f;
  }

  .intelligence_card_content h3 {
    margin: 0;
    font-size: clamp(1.1rem, 1.25vw, 2.25rem);
    line-height: 1.1;
  }

  .intelligence_kpis {
    display: flex;
    gap: clamp(1rem, 0.5rem + 0.8vw, 2.5rem);
    margin-top: clamp(1.25rem, 0.75rem + 0.8vw, 2.5rem);
    padding-top: clamp(1.25rem, 0.75rem + 0.8vw, 2.5rem);
    border-top: 1px solid #45464d;
  }

  .intelligence_kpi {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: clamp(0.25rem, 0.15rem + 0.12vw, 0.5rem);
    min-width: 0;
  }

  .intelligence_kpi strong {
    color: #fff;
    font-size: clamp(1rem, 1vw, 1.9rem);
    line-height: 1;
  }

  .intelligence_kpi span {
    color: #b9bac1;
    font-size: clamp(0.625rem, 0.6vw, 0.95rem);
    line-height: 1.2;
    letter-spacing: 0.04em;
  }

  .intelligence_arrow {
    display: inline-flex;
    width: clamp(2rem, 1.5rem + 0.5vw, 3rem);
    height: clamp(2rem, 1.5rem + 0.5vw, 3rem);
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1px solid var(--pax-white);
    border-radius: 50%;
  }

  .intelligence_arrow img {
    width: clamp(0.9rem, 0.65rem + 0.25vw, 1.35rem);
    height: auto;
  }
</style>
